import { eventBus } from '../eventBus';

/**
 * Emit `form.validation.failed` so the critical-flow tracer (which captures
 * eventBus emissions) can see which fields blocked the save. MUST be called
 * by every Form.vue's validateForm() before returning false.
 *
 * @param formId  The component name, e.g. 'SOServicePrioritiesForm'
 * @param errors  The form's reactive `errors` object — keys are field names,
 *                values are localized error messages (empty string = no error)
 */
export function emitValidationFailed(
  formId: string,
  errors: Record<string, string>,
): void {
  const failedFields = Object.entries(errors)
    .filter(([, msg]) => Boolean(msg))
    .map(([field]) => field);
  if (!failedFields.length) return;
  eventBus.emit('form.validation.failed', { formId, failedFields, errors: { ...errors } });
}
